var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91827 5.48071L1.68927 0.288696C1.5031 0.10403 1.25148 0.000426696 0.989258 0.000426685C0.727033 0.000426673 0.475419 0.10403 0.289246 0.288696C0.197603 0.379446 0.124842 0.487471 0.0751953 0.606506C0.0255489 0.72554 -3.72948e-08 0.853204 -4.29323e-08 0.982177C-4.85699e-08 1.11115 0.0255489 1.23888 0.0751953 1.35791C0.124842 1.47694 0.197603 1.58497 0.289246 1.67572L6.21722 7.56067C6.40327 7.74558 6.65493 7.84936 6.91724 7.84936C7.17954 7.84936 7.4312 7.74558 7.61725 7.56067L13.5452 1.67572C13.6369 1.58497 13.7096 1.47694 13.7593 1.35791C13.8089 1.23888 13.8345 1.11115 13.8345 0.982178C13.8345 0.853205 13.8089 0.725541 13.7593 0.606506C13.7096 0.487472 13.6369 0.379447 13.5452 0.288696C13.3592 0.103789 13.1075 -3.17761e-08 12.8452 -4.32418e-08C12.5829 -5.47075e-08 12.3313 0.103789 12.1453 0.288696L6.91827 5.48071Z",
    fill: "#6930ca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.a9cae657196b5673f11317783c928968.svg";
export { ForwardRef as ReactComponent };